export const storesNameRoot = 'appAuthorizationStore';
